













































































import "vue-loading-overlay/dist/vue-loading.css";
import "flatpickr/dist/flatpickr.css";
import defineAbilityFor from "@/services/ability";
import { Component, Vue } from "vue-property-decorator";
import QScripts from "@/common/qScripts.vue";
import click2Top from "@/common/directives/click2Top";

@Component({
  name: "QAdmin",
  components: {
    QScripts,
  },
  directives: {
    click2Top,
  },
})
export default class QAdmin extends Vue {
  public isShow = true;
  async created(): Promise<void> {
    // await store.dispatch("Auth/fetchCurrentUser");
    // // check user using what the company
    // this.isShow = true;
    // let roleId = null;
    // if (this.$store.state.Auth.using_company) {
    //   for (const userCompany of this.$store.state.Auth.userCompanies) {
    //     if (userCompany.id === this.$store.state.Auth.using_company) {
    //       roleId = userCompany.role_id;
    //     }
    //   }
    // }
    this.$store.state.Auth.userLogging &&
      this.$ability.update(
        defineAbilityFor(this.$store.state.Auth.userLogging.role).rules
      );
  }

  async mounted() {
    this.$nextTick(() => {
      (this.$refs.script as QScripts).muuqBase();
    });
  }
}
